import {
  Grid, Box, Typography,
  Accordion, AccordionSummary, AccordionDetails,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useTheme, alpha } from "@mui/material/styles";
import { useTranslation } from "../../../language";

import GetBmi from "./SectionVitals/BodyShape/GetBmi";
import DiaAddHeight from "./SectionVitals/BodyShape/DiaAddHeight";

import BpPanel from "./SectionVitals/BloodPressure/BpPanel";

// ─── Shared accordion style ───────────────────────────────────────────────────

function accordionSx(theme) {
  return {
    borderRadius: "16px !important",
    overflow: "hidden",
    "&:before": { display: "none" },
    bgcolor: theme.palette.mode === "dark" ? alpha("#fff", 0.04) : alpha("#fff", 0.5),
    backdropFilter: "blur(28px) saturate(180%)",
    WebkitBackdropFilter: "blur(28px) saturate(180%)",
    border: `1px solid ${theme.palette.mode === "dark" ? "rgba(255,255,255,0.08)" : "rgba(255,255,255,0.65)"}`,
    boxShadow: theme.palette.mode === "dark"
      ? "inset 0 1px 0 rgba(255,255,255,0.06), 0 8px 32px rgba(0,0,0,0.55)"
      : "inset 0 1px 0 rgba(255,255,255,0.7), 0 4px 24px rgba(0,0,0,0.06)",
  };
}

const summarySx = {
  px: 2.5,
  bgcolor: "transparent",
  minHeight: 44,
  "& .MuiAccordionSummary-content": { my: 0.5, display: "flex", alignItems: "center", gap: 1, pr: 2 },
};

// ─── Component ────────────────────────────────────────────────────────────────

export default function VitalsDashboard() {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Grid container justifyContent="center" sx={{ mt: 1, mb: 10, width: "100%" }}>

      {/* ── Body Shape & BMI ─────────────────────────────────────────────── */}
      <Grid size={12} sx={{ display: "flex", justifyContent: "center", px: { xs: 2, md: 0 }, mb: 3 }}>
        <Box sx={{ width: "100%", maxWidth: { xs: 800, md: 900 } }}>
          <Accordion defaultExpanded disableGutters elevation={0}
            sx={accordionSx(theme)}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={summarySx}>
              <Typography variant="subtitle2" fontWeight={700}
                sx={{ textTransform: "uppercase", letterSpacing: 0.4 }}>
                {t("vitals_body_shape")}
              </Typography>
            </AccordionSummary>

            <AccordionDetails sx={{ p: 0 }}>
              <GetBmi />
            </AccordionDetails>
          </Accordion>
        </Box>
      </Grid>

      {/* ── Blood Pressure ───────────────────────────────────────────────── */}
      <Grid size={12} sx={{ display: "flex", justifyContent: "center", px: { xs: 2, md: 0 }, mb: 3 }}>
        <Box sx={{ width: "100%", maxWidth: { xs: 800, md: 900 } }}>
          <BpPanel />
        </Box>
      </Grid>

    </Grid>
  );
}
